<!-- We need to add a button here in this way because this form is not an "overview" style form and so does not nicely
  allow for a form navigation page (that normally contains the Home button) to be added at the top of the form configuration.
  Furthermore, it is using the dspx-card-set-base-with-header-form component, which has a header component above the
  form content. So even if this form was using the "overview" style, the Home button would not appear above the header. -->
<button pButton
        id="home"
        type="button"
        label="Home"
        title="Home"
        icon="pi pi-home"
        iconPos="right"
        (click)="home($event)"
        attr.aria-disabled="false">
</button>
<dspx-card-set-base-with-header-form [formServiceEndpoint]="formServiceEndpoint"
                                     [fieldTypeReplacements]="fieldTypeReplacements"
                                     [verticalNavigationSettings]="verticalNavigationSettings"
                                     [formHeaderModel]="formHeaderModel"
                                     [templateId]="templateId"
                                     [versionNo]="versionNo"
                                     [entityId]="id"
                                     formName="Non Mains Water Concession Application"
                                     (onButtonClick)="buttonClick($event)"
                                     (onActionButtonClick)="actionButtonClick($event)"
                                     (onDialogSubmit)="dialogSubmit($event)"
                                     (onFormLoad)="formLoaded($event)"
                                     (onModelChange)="modelChange($event)"
                                     (onSave)="save($event)"
                                     (onCancel)="cancel($event)">
</dspx-card-set-base-with-header-form>
